
import AppRouter from "./approuter.jsx";

import { AuthProvider, useAuth } from "./context/AuthContext";

const App = () => {
  // const config = "/template/react";
  //"/react/template/"



  return (
        <AuthProvider>
    <AppRouter/>
    </AuthProvider>
  );
};

export default App;
